import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Award } from "lucide-react";
import heroImage from "@/assets/hero-vitrerie-optimized.webp";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroImage} 
          alt="Nettoyage professionnel de vitrerie" 
          className="w-full h-full object-cover"
          width="1024"
          height="576"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/80 to-background/50"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-32 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="flex flex-wrap gap-3 mb-6 animate-fade-up">
            <Badge variant="secondary" className="bg-secondary/90 backdrop-blur-sm text-secondary-foreground flex items-center gap-1.5 px-4 py-1.5">
              <Award className="h-4 w-4" />
              Depuis 2015 à Nantes
            </Badge>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold mb-6">
            Expert en{" "}
            <span className="bg-gradient-primary bg-clip-text text-transparent">
              Nettoyage Professionnel
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-muted-foreground mb-8 animate-fade-up leading-relaxed" style={{ animationDelay: '0.2s' }}>
            EPP Espaces Paysages & Propreté : Votre partenaire de confiance pour tous vos besoins en nettoyage à Nantes et sa région depuis 2015
          </p>

          <ul className="space-y-3 mb-8 animate-fade-up" style={{ animationDelay: '0.3s' }}>
            {[
              "Nettoyage de vitrerie et façades",
              "Entretien de bureaux et espaces commerciaux",
              "Maintenance d'espaces verts professionnels",
              "Nettoyage industriel et multiservices"
            ].map((item, index) => (
              <li key={index} className="flex items-center gap-3 group">
                <div className="bg-primary/10 rounded-full p-1 group-hover:bg-primary/20 transition-colors">
                  <CheckCircle2 className="h-5 w-5 text-primary flex-shrink-0" />
                </div>
                <span className="text-foreground font-medium">{item}</span>
              </li>
            ))}
          </ul>

          <div className="flex flex-col sm:flex-row gap-4 animate-fade-up" style={{ animationDelay: '0.4s' }}>
            <Link to="/devis">
              <Button size="lg" className="bg-gradient-primary hover:shadow-glow transition-all group text-base">
                Demander un devis gratuit
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <Link to="/services">
              <Button size="lg" variant="outline" className="hover:bg-primary/10 border-2 transition-all text-base">
                Découvrir nos services
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
